import { render, staticRenderFns } from "./AppLista.vue?vue&type=template&id=f61517ce&"
import script from "./AppLista.vue?vue&type=script&lang=js&"
export * from "./AppLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports